<div class="app-layout__sidebar">
  <div class="sidebar">
    <button
      (click)="onClickReturn()"
      class="sidebar__close"
      id="close-sidebar-drawer"
    >
      {{ 'sharedModule.bkgSummary.return' | translate }}
    </button>

    <section
      class="sidebar__section is-open"
      *ngIf="showSections.isConfirmation"
    >
      <h5 class="h5 sidebar__section-title">
        {{ 'sharedModule.bkgSummary.reservationNumber' | translate }}
      </h5>
      <div class="sidebar__content">
        <div class="sidebar__content-item">
          <span>{{ reservation.id }}</span>
        </div>
      </div>
    </section>

    <section
      class="sidebar__section is-open"
      *ngIf="showSections.isConfirmation"
    >
      <bkg-summary-reservation
        [reservation]="reservation"
      ></bkg-summary-reservation>
    </section>

    <section
      class="sidebar__section is-open"
      *ngIf="showSections.canShowBookingData"
    >
      <bkg-summary-booking-data
        [bookingData]="bookingData$ | async"
        [tripData]="tripData$ | async"
        [readOnly]="showSections.isConfirmation"
        [isUrbanParkin]="isUrbanParkin"
        (modifyBookingData)="onModifyBookingData()"
        [selectedVoucherCode]="selectedVoucherCode"
        [vouchers]="availableVouchers"
      ></bkg-summary-booking-data>
    </section>

    <section *ngIf="showAvailableVouchers" class="sidebar__section is-open">
      <bkg-summary-vouchers
        (addVoucherCodeReturn)="calculateWithPromoCode($event)"
        [vouchers]="availableVouchers"
      ></bkg-summary-vouchers>
    </section>

    <section
      class="sidebar__section is-open"
      *ngIf="showSections.canShowLocation"
    >
      <bkg-summary-location
        [vouchers]="availableVouchers"
        [imgShow]="imgShow"
        [authData]="authData$ | async"
        [terminalPlace]="terminalPlace"
        [readOnly]="showSections.isConfirmation"
        [vouchers]="availableVouchers.length"
      ></bkg-summary-location>
    </section>

    <section
      class="sidebar__section is-open"
      *ngIf="showSections.canShowVehicle && vehicleData$ | async"
    >
      <bkg-summary-vehicle
        [vehicle]="vehicleData$ | async"
        [readOnly]="readOnlyVehicleSection"
        (modifyVehicleReturn)="onModifyVehicle($event)"
        (changeVehicleReturn)="onChangeVehicle($event)"
        (modifyVehicleKmReturn)="onModifyVehicleKm($event)"
      ></bkg-summary-vehicle>
    </section>

    <section class="sidebar__section is-open" *ngIf="showSections.canShowPrice">
      <bkg-summary-price
        [offerData]="offerData$ | async"
        [readOnly]="
          showSections.isConfirmation || showSections.disableFromUrban
        "
        [bookingData]="bookingData$ | async"
        [sourceMode]="sourceMode$ | async"
        [tripData]="tripData$ | async"
        (removeCarServiceReturn)="onRemoveCarService($event)"
        (removeExtraReturn)="onRemoveExtra($event)"
        (removePromoReturn)="onRemovePromo()"
        (removePointsReturn)="onRemovePoints()"
        [testABMode]="testABMode"
      ></bkg-summary-price>
    </section>

    <section class="sidebar__web sidebar__section sidebar__checkout">
      <div
        *ngIf="showSections.canShowDiscounts"
        class="sidebar__checkout-extra"
      >
        <bkg-summary-discounts
          [userData]="userData"
          [offerData]="offerData$ | async"
          [promoLoaded]="promoLoaded"
          [promoCode]="promoCode"
          [isLoadingCode]="isLoadingCode"
          [isLoadingPromo]="isLoadingPromo"
          (addRedeemReturn)="calculateWithRedeem()"
          (addPromoCodeReturn)="calculateWithPromoCode($event)"
          (closeFailPromoReturn)="cleanPromo()"
        ></bkg-summary-discounts>
      </div>
      <div
        *ngIf="showSections.canShowTerms || showTermsOnModify"
        class="sidebar__checkout-terms"
      >
        <div class="form-group">
          <div *ngIf="hasCarService">
            <input
              type="checkbox"
              [(ngModel)]="carServiceTerms"
              id="carServiceTerms"
            />
            <label for="carServiceTerms" class="sidebar__terms-text">{{
              'sharedModule.bkgSummary.carServiceTerms' | translate
            }}</label>
            <input
              type="checkbox"
              [(ngModel)]="carInsuranceTerms"
              id="carInsuranceTerms"
            />
            <label for="carInsuranceTerms" class="sidebar__terms-text">{{
              'sharedModule.bkgSummary.carInsuranceTerms' | translate
            }}</label>
          </div>
          <div *ngIf="showAcceptPromos">
            <input
              type="checkbox"
              [(ngModel)]="acceptPromos"
              id="acceptPromos"
            />
            <label
              for="acceptPromos"
              [innerHTML]="'sharedModule.bkgSummary.acceptPromos' | translate"
              class="sidebar__terms-text"
            >
            </label>
          </div>
          <div *ngIf="showAcceptNewsletter">
            <input
              type="checkbox"
              [(ngModel)]="acceptNewsletter"
              id="acceptNewsletter"
            />
            <label
              for="acceptNewsletter"
              [innerHTML]="
                'sharedModule.bkgSummary.acceptNewsletter' | translate
              "
              class="sidebar__terms-text"
            >
            </label>
          </div>
          <div *ngIf="isGuest">
            <input type="checkbox" [(ngModel)]="acceptTerms" id="acceptTerms" />
            <label
              for="acceptTerms"
              [innerHTML]="'sharedModule.bkgSummary.acceptTerms' | translate"
              class="sidebar__terms-text"
            ></label>
          </div>
        </div>
      </div>

      <div
        *ngIf="nextButtonVisible && !showTermsOnModify"
        attr.data-text="{{
          'sharedModule.bkgSummary.needServices' | translate
        }}"
        [class.tooltip]="disableContinue"
      >
        <button
          *ngIf="nextButtonVisible && !showTermsOnModify"
          (click)="onContinue()"
          [class.btn-disabled]="showLoadingButton"
          [disabled]="disableContinue"
          type="button"
          class="btn-primary btn-large is-block"
        >
          <span *ngIf="!showLoadingButton && !erpMode">{{
            'sharedModule.bkgSummary.continue' | translate
          }}</span>
          <span *ngIf="!showLoadingButton && erpMode">{{
            'sharedModule.bkgLinkReservationDialog.saveBtn' | translate
          }}</span>
          <div *ngIf="showLoadingButton" class="white-spinner__small"></div>
        </button>
      </div>
      <div
        *ngIf="bookButtonVisible || showTermsOnModify"
        [attr.data-text]="tooltipMessage"
        [class.tooltip]="disableBooking"
        (mouseover)="checkForms()"
      >
        <button
          *ngIf="bookButtonVisible || showTermsOnModify"
          (click)="onClickBooking()"
          [disabled]="disableBooking"
          [class.btn-disabled]="showLoadingButton"
          type="button"
          class="btn-primary btn-large is-block"
        >
          <span *ngIf="!showLoadingButton">
            {{
              (!isModifyData && !showTermsOnModify
                ? 'sharedModule.bkgSummary.book'
                : 'sharedModule.bkgLinkReservationDialog.saveBtn'
              ) | translate
            }}
          </span>
          <div *ngIf="showLoadingButton" class="white-spinner__small"></div>
        </button>
        <label
          *ngIf="!isGuest"
          class="sidebar__terms-text sidebar__accepted-terms"
          [innerHTML]="'sharedModule.bkgSummary.termsAccepted' | translate"
        ></label>
        <label *ngIf="hasCarService" class="sidebar__terms-text">{{
          'sharedModule.bkgSummary.estimateAccept' | translate
        }}</label>
      </div>
    </section>
  </div>
</div>
